import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';
import CopyPageButton from './CopyPageButton';

const Navigation = ({ onToggleToc, showTocButton = false }) => {
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Blog', path: '/blog' }
  ];

  return (
    <nav className="w-full border-b border-gray-300 dark:border-gray-800 mb-8 lg:relative sticky top-0 z-40 bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm">
      <div className="flex items-center justify-between py-4">
        {/* Mobile TOC Button (left side) */}
        {showTocButton && (
          <button
            onClick={onToggleToc}
            className="lg:hidden p-2 -ml-2 rounded hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            aria-label="Toggle table of contents"
          >
            <svg className="w-6 h-6 text-gray-700 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        )}

        {/* Navigation Links (center) */}
        <div className="flex items-center justify-center gap-8 flex-1">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-sm font-medium tracking-wide transition-colors ${
                isActive(item.path)
                  ? 'text-blue-600 dark:text-blue-400'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              }`}
            >
              {item.name}
            </Link>
          ))}
        </div>

        {/* Right side actions */}
        <div className="flex items-center gap-1">
          <CopyPageButton />
          <ThemeToggle />
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
